import React from 'react';
import { Grid, Loader } from 'semantic-ui-react';

export default function LoadingScreen(props) {
  return (
    <Grid className="fullheight fullwidth loginpage" padded centered verticalAlign="middle">
      <Grid.Column width={5}>
        <Loader active inverted size="large" inline="centered" />
      </Grid.Column>
    </Grid>
  )
}


// WEBPACK FOOTER //
// ./src/common/LoadingScreen.js